import Meeting from '@/customer-portal/meeting/entities/meeting'

export default class MeetingResponse {
  public items: Meeting[]
  public totalCount: number
  public limit: number
}
